import type { PropertyType } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const propertyTypeSchema = z.enum(['select', 'number', 'section']) as unknown as ToZod<PropertyType>

export type PropertyTypeSchema = PropertyType